import { takeLatest, put, call } from 'redux-saga/effects';
import { HTTP_HEADERS, HTTP_HEADERS_FORMDATA, HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../../constants';
import request from '../../../components/Utils/httpHelper';
import * as RiskfactorListActions from './action';
import { SCORE_DEFINATION } from '../../../config';

export function* loadRiskFactorList(action) {
    let requestUrl = `${SCORE_DEFINATION}/riskfactor/list/all`;
    try {
        const createResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(RiskfactorListActions.riskFactorListSuccess(createResult));
    } catch (err) {
        yield put(RiskfactorListActions.riskFactorListFailure(err))
    }
}
export function* listRiskFactor() {
    yield takeLatest(RiskfactorListActions.RISKFACTOR_LIST, loadRiskFactorList);
}


export function* riskfactorEditTemplate(action) {
    let requestUrl = `${SCORE_DEFINATION}/riskfactor/bulk/edit`;
    try {
        const listResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(RiskfactorListActions.downloadEditRiskFactorTemplateSuccess(listResult.data));
    } catch (err) {
        yield put(RiskfactorListActions.downloadEditRiskFactorTemplateFailure(err.response))
    }
}
export function* downloadRiskfactorEditTemplate() {
    yield takeLatest(RiskfactorListActions.DOWNLOAD_EDIT_RISK_FACTOR_TEMPLATE, riskfactorEditTemplate);
}


export function* uploadRiskfactorEdit(action) {
    let requestUrl = `${SCORE_DEFINATION}/riskfactor/bulk/edit`;
    try {
        const formData = new FormData();
        formData.append('file', action.data)
        const listResult = yield call(request, requestUrl, { data: formData, method: 'POST', headers: HTTP_HEADERS_FORMDATA });
        yield put(RiskfactorListActions.uploadEditRiskFactorTemplateSuccess(listResult.data));
    } catch (err) {
        yield put(RiskfactorListActions.uploadEditRiskFactorTemplateFailure(err.response))
    }
}
export function* uploadRiskfactorEditTemplate() {
    yield takeLatest(RiskfactorListActions.UPLOAD_EDIT_RISK_FACTOR_TEMPLATE, uploadRiskfactorEdit);
}